import { ActionRegistryCategory } from '../../ActionRegistryCategory';
import { ActionRegistryItem } from '../../ActionRegistryItem';
export class ActionsAsking extends ActionRegistryCategory {
    label = 'Asking';
    constructor(parent) {
        super(parent);
        super.init();
    }
    addAskingMark = () => new ActionRegistryItem({
        action: ({ app, at }) => {
            app.asking.askingMarks.addMark(at.local.valueOf.markName);
        },
        params: {
            core: ['markName'],
        },
    });
}
